import { uiText, useUiLanguage } from '@/i18n/interface';

import React, { useState } from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FormData } from '../../utils/formValidation';
import PasswordStrengthIndicator from '../PasswordStrengthIndicator';

interface PasswordFieldsProps {
  formData: FormData;
  updateFormData: (field: string, value: string) => void;
}

const PasswordFields: React.FC<PasswordFieldsProps> = ({ formData, updateFormData }) => {
  useUiLanguage();
  const [isPasswordStrong, setIsPasswordStrong] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState<string[]>([]);

  const handlePasswordStrengthChange = (isStrong: boolean, errors: string[]) => {
    setIsPasswordStrong(isStrong);
    setPasswordErrors(errors);
  };

  return (
    <>
      <div className="md:col-span-2">
        <Label htmlFor="password">{uiText("Password *")}</Label>
        <Input
          id="password"
          type="password"
          value={formData.password}
          onChange={(e) => updateFormData('password', e.target.value)}
          required
          minLength={12}
        />
        <PasswordStrengthIndicator
          password={formData.password}
          onStrengthChange={handlePasswordStrengthChange}
        />
      </div>
      <div className="md:col-span-2">
        <Label htmlFor="confirmPassword">{uiText("Confirm Password *")}</Label>
        <Input
          id="confirmPassword"
          type="password"
          value={formData.confirmPassword}
          onChange={(e) => updateFormData('confirmPassword', e.target.value)}
          required
          minLength={12}
        />
        {formData.password && formData.confirmPassword && formData.password !== formData.confirmPassword && (
          <p className="text-xs text-red-600 mt-1">{uiText("Passwords do not match")}</p>
        )}
      </div>
    </>
  );
};

export default PasswordFields;
